// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2k7IT","label":"CategoryService_label__1Abdn","location":"CategoryService_location__3rxRq"};